import { render, staticRenderFns } from "./Pos.vue?vue&type=template&id=54b76f25&scoped=true&"
import script from "./Pos.vue?vue&type=script&lang=js&"
export * from "./Pos.vue?vue&type=script&lang=js&"
import style0 from "./_layout.css?vue&type=style&index=0&id=54b76f25&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b76f25",
  null
  
)

export default component.exports